var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "feature-toggle",
      on: {
        click: function ($event) {
          return _vm.switchToggle()
        },
      },
    },
    [
      _c(
        "div",
        [
          _c("b-button", {
            attrs: { pressed: _vm.state, variant: _vm.variant },
          }),
          _vm._v("\n        " + _vm._s(_vm.name) + "\n    "),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "span",
          {
            class: {
              badge: true,
              "badge-toggle-state": _vm.hasLocalState,
              "badge-toggle-state-outline": !_vm.hasLocalState,
              "badge-toggle-state-enabled": _vm.localToggleState,
            },
          },
          [_vm._v("L")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            class: {
              badge: true,
              "badge-toggle-state": true,
              "badge-toggle-state-enabled": _vm.serverToggleState,
            },
          },
          [_vm._v("S")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }